export const contact = {
  // Hero
  heroTitle: 'İletişime Geçin',
  heroSubtitle: 'Projeniz için doğru çözümü bulmaya hazır mısınız? Çorlu\'daki merkez ofisimizle konuşalım.',
  
  // Contact Info
  address: 'Adres',
  addressValue: 'Şeyh Sinan, Hüsmen Kalfa Sk. No:5/33, 59850 Çorlu/Tekirdağ',
  phone: 'Telefon',
  phoneValue: '+90 530 095 97 41',
  email: 'E-posta',
  emailValue: 'info@dynamixsteelfiber.com',
  instagram: 'Instagram',
  instagramValue: '@dynamixsteelfiber',
  whatsapp: 'WhatsApp',
  whatsappValue: '+90 530 095 97 41',
  
  // Form
  formTitle: 'Bize Mesaj Gönderin',
  fullName: 'Ad Soyad',
  fullNamePlaceholder: 'Ahmet Yılmaz',
  companyName: 'Şirket Adı',
  companyNamePlaceholder: 'ABC İnşaat',
  emailAddress: 'E-posta Adresi',
  emailPlaceholder: 'ornek@email.com',
  phoneNumber: 'Telefon Numarası',
  phonePlaceholder: '+90 (123) 456-7890',
  message: 'Mesaj',
  messagePlaceholder: 'Proje gereksinimleriniz hakkında bize bilgi verin...',
  required: '*',
  characters: 'karakter',
  sendMessage: 'Mesaj Gönder',
  sending: 'Gönderiliyor...',
  
  successMessage: 'Teşekkürler! Mesajınız başarıyla gönderildi. En kısa sürede size geri döneceğiz.',
  errorMessage: 'Üzgünüz, mesajınız gönderilirken bir hata oluştu. Lütfen tekrar deneyin veya doğrudan bizimle iletişime geçin.',
  
  // Map
  mapTitle: 'Konumumuz',
  mapSubtitle: 'Çorlu, Tekirdağ\'daki tesisimizi ziyaret edin',
  
  // Business Hours
  hoursTitle: 'Çalışma Saatleri',
  officeHours: 'Ofis Saatleri',
  mondayFriday: 'Pazartesi - Cuma:',
  mondayFridayTime: '08:00 - 18:00',
  saturday: 'Cumartesi:',
  saturdayTime: '09:00 - 14:00',
  sunday: 'Pazar:',
  sundayTime: 'Kapalı',
  
  productionFacility: 'Üretim Tesisi',
  productionMF: 'Pazartesi - Cuma:',
  productionMFTime: '7/24 Operasyon',
  productionWeekend: 'Hafta Sonu:',
  productionWeekendTime: 'Talep Üzerine',
};
